/**
 * Formateo de moneda del Panel Comerciales.
 *
 * Contrato: los valores viajan SIEMPRE numéricos al backend (sin separadores).
 * El formateo a `$1,234,567` es responsabilidad exclusiva de la UI. Estas
 * funciones son la fuente única para mostrar y para parsear lo que el usuario
 * escribe, de modo que todos los campos numéricos del panel se vean igual.
 */

/** Extrae los dígitos de una cadena y los convierte a número. `undefined` si no hay dígitos. */
export const parseCurrencyToNumber = (raw: string | number | null | undefined): number | undefined => {
    if (typeof raw === 'number') return Number.isFinite(raw) ? Math.trunc(raw) : undefined;
    const digits = (raw ?? '').replace(/\D/g, '');
    if (!digits) return undefined;
    const n = Number(digits);
    return Number.isFinite(n) ? n : undefined;
};

/** Formatea un número o cadena numérica como `$1,234,567` (sin decimales). Vacío si no hay valor. */
export const formatCurrencyMX = (value: string | number | null | undefined): string => {
    const n = parseCurrencyToNumber(value ?? '');
    if (n === undefined) return '';
    return `$${n.toLocaleString('en-US')}`;
};

/**
 * Formatea lo que el usuario escribe en un input: descarta cualquier
 * carácter no numérico y reformatea como `$1,234,567`. Devuelve cadena vacía
 * si no quedan dígitos (permite borrar el campo).
 */
export const formatCurrencyInput = (raw: string): string => {
    const n = parseCurrencyToNumber(raw);
    if (n === undefined) return '';
    return `$${n.toLocaleString('en-US')}`;
};
